import { useHistory } from 'react-router-dom';

export default function withRouterHistoryHook(Component) {
    return function WrappedComponent(props) {
        const history = useHistory();
        return <Component history={history} {...props} />;
    };
};